import { useMutation } from "@tanstack/react-query"
import { createTilledPaymentMethod } from "../tilledClient"
import type { CreateTilledPaymentMethodParams, TilledPaymentMethod } from "../tilledClient"
import { callNativeAlert, Sentry } from "../../utils"

export function useCreateTilledPaymentMethod() {
  return useMutation<TilledPaymentMethod, unknown, CreateTilledPaymentMethodParams>({
    mutationFn: createTilledPaymentMethod,
    onError: (e) => {
      Sentry.captureException(e)
      callNativeAlert("Unable to use this payment method")
    },
  })
}
